export const PHONE_NUMBER_MASK_CONSTANT = "+70000000000";
export const PHONE_NUMBER_MASK_CONSTANT_WITH_WHITESPACE = "+7 000 000 00 00"